import React from 'react';
import AdminLayout from '../Componets/AdminLayout';
import { Link } from 'react-router-dom';
import StorageChart from '../Admin/Chart/StorageChart';

export default function Chart() {
  return (
    <AdminLayout ac11="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item ">
                {' '}
                <Link to="/ReportDashbord">Report Exams</Link>{' '}
              </li>
              <li className="breadcrumb-item active">Report chart </li>
            </ol>
          </nav>
        </div>
        <section id="stats" className="stats section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <StorageChart />
          </div>
        </section>
      </main>
    </AdminLayout>
  );
}
